import { ReactNode } from 'react';

import { ZenotiError } from '@src/utils/error-handling';

export type SchedulingStep = {
	title: string;
	component: ReactNode;
};

export type TimeslotsResponseType = {
	date: string;
	slots: ZenotiTimeslot[];
}[];

export type ZenotiTimeslotsResponse = {
	future_days: {
		Day: string;
		IsAvailable: boolean;
	}[];
	next_available_day: string | null;
	slots: ZenotiTimeslot[];
	Error: ZenotiError | null;
};

export type ZenotiBookingResponse = {
	id: string;
	Error: ZenotiError | null;
};

export type ZenotiTimeslot = {
	Available: boolean;
	Time: string;
};

export declare enum BffBrandType {
	AspenDental = 'ASPEN_DENTAL',
	AzPet = 'AZ_PET',
	Chapter = 'CHAPTER',
	ClearChoice = 'CLEAR_CHOICE',
	Lovet = 'LOVET',
	WellNow = 'WELL_NOW',
}

export enum RequestStatus {
	NotAsked = 'NOTASKED',
	Loading = 'LOADING',
	Success = 'SUCCESS',
	Failure = 'FAILURE',
}
